import { render, staticRenderFns } from "./CriarPrograma.vue?vue&type=template&id=884ec0fa&scoped=true"
import script from "./CriarPrograma.vue?vue&type=script&lang=js"
export * from "./CriarPrograma.vue?vue&type=script&lang=js"
import style0 from "./CriarPrograma.vue?vue&type=style&index=0&id=884ec0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ec0fa",
  null
  
)

export default component.exports